import React from "react";
import { LuLoader2 } from "react-icons/lu";

const Loader = ({ size, className }: { size?: number; className?: string }) => {
  return (
    <>
      <LuLoader2
        className={`text-orange-400 animate-spin ${className} `}
        size={size || 50}
      />
    </>
  );
};

export default Loader;
